import BooleanParamType from './ParamTypes/BooleanParamType';
import CodeBlockParamType from './ParamTypes/CodeBlockParamType';
import DefaultParamType from './ParamTypes/DefaultParamType';
import EmailTemplateParamType from './ParamTypes/EmailTemplateParamType';
import EmailTemplatesParamType from './ParamTypes/EmailTemplatesParamType';
import IdentityParamType from './ParamTypes/IdentityParamType';
import InboxParamType from './ParamTypes/InboxParamType';
import IntegerParamType from './ParamTypes/IntegerParamType';
import InternalEntityParamType from './ParamTypes/InternalEntityParamType.vue';
import ItemKeyValueParamType from './ParamTypes/ItemKeyValueParamType/ItemKeyValueParamType';
import ItemParamType from './ParamTypes/ItemParamType/ItemParamType';
import JSONParamType from './ParamTypes/JSONParamType';
import ListParamType from './ParamTypes/ListParamType';
import InListBooleanParamType from './ParamTypes/ListParams/InListBooleanParamType';
import InListDefaultParamType from './ParamTypes/ListParams/InListDefaultParamType';
import InListIntegerParamType from './ParamTypes/ListParams/InListIntegerParamType';
import InListStringParamType from './ParamTypes/ListParams/InListStringParamType';
import MultipleItemParamType from './ParamTypes/MultipleItemParamType/MultipleItemParamType';
import MultipleSelectParamType from './ParamTypes/MultipleSelectParamType';
import OptionalParamsPickerParamType from './ParamTypes/OptionalParamsPickerParamType';
import RulesParamType from './ParamTypes/RulesParamType';
import SelectParamType from './ParamTypes/SelectParamType';
import StringParamType from './ParamTypes/StringParamType';
import TemplateEditorParamType from './ParamTypes/TemplateEditorParamType';

export const SELECT_PARAM_TYPE = 'select';

export const PARAM_TYPES_MAP = {
	item: ItemParamType,
	json: JSONParamType,
	list: ListParamType,
	inbox: InboxParamType,
	rules: RulesParamType,
	string: StringParamType,
	boolean: BooleanParamType,
	default: DefaultParamType,
	integer: IntegerParamType,
	identity: IdentityParamType,
	code_block: CodeBlockParamType,
	textparser: TemplateEditorParamType,
	[SELECT_PARAM_TYPE]: SelectParamType,
	multiple_item: MultipleItemParamType,
	item_key_value: ItemKeyValueParamType,
	emailtemplate: EmailTemplatesParamType,
	email_template: EmailTemplateParamType,
	internal_entity: InternalEntityParamType,
	multiple_select: MultipleSelectParamType,
	optional_params_picker: OptionalParamsPickerParamType,
};

export const IN_LIST_PARAM_TYPES_MAP = {
	string: InListStringParamType,
	boolean: InListBooleanParamType,
	integer: InListIntegerParamType,
	default: InListDefaultParamType,
};
